/**
 * Generated runtime TestId mirror for frontend/src/components/owners/OwnersSection.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const OwnersSectionTestIds = {
  addOwnerForm: "add-owner-form",
  btnAddOwner: "btn-add-owner",
  btnCancelAddOwner: "btn-cancel-add-owner",
  btnSaveAddOwner: "btn-save-add-owner",
  colOwnerActions: "col-owner-actions",
  colOwnerParty: "col-owner-party",
  colOwnerResponsibility: "col-owner-responsibility",
  colOwnerValidFrom: "col-owner-valid-from",
  colOwnerValidTo: "col-owner-valid-to",
  comboboxAddOwnerParty: "combobox-add-owner-party",
  responsibilityLookupMissingError: "responsibility-lookup-missing-error",
  sectionOwners: "section-owners",
  selectAddOwnerResponsibility: "select-add-owner-responsibility",
  btnRemoveOwner: (ownerPartyId_owner: string) => `btn-remove-owner-${ownerPartyId_owner}`,
  btnRemoveOwnerPrefix: () => "btn-remove-owner-" as TestIdPrefix,
  optionResponsibility: (opt_code: string) => `option-responsibility-${opt_code}`,
  optionResponsibilityPrefix: () => "option-responsibility-" as TestIdPrefix,
  rowOwner: (ownerPartyId_owner: string) => `row-owner-${ownerPartyId_owner}`,
  rowOwnerPrefix: () => "row-owner-" as TestIdPrefix
} as const;
